const iconList = [
    "#food-icon-a-001-drink",
    "#food-icon-a-011-food",
    "#food-icon-a-005-snack",
    "#food-icon-a-003-food",
    "#food-icon-a-009-snack",
    "#food-icon-a-002-food",
    "#food-icon-a-013-food",
    "#food-icon-a-019-food",
    "#food-icon-a-007-food",
    "#food-icon-a-012-bread",
    "#food-icon-a-004-meat",
    "#food-icon-a-017-strawberry",
    "#food-icon-a-006-strawberry",
    "#food-icon-a-020-cheese",
    "#food-icon-a-015-food",
    "#food-icon-a-018-strawberry",
    "#food-icon-a-010-food",
    "#food-icon-a-028-healthy",
    "#food-icon-a-012-drink",
    "#food-icon-a-030-drink",
    "#food-icon-a-005-softdrinkcan",
    "#food-icon-a-018-hotamericano",
    "#food-icon-a-026-drink",
    "#food-icon-a-024-drink",
    "#food-icon-a-001-sweet",
    "#food-icon-a-003-whiskey",
    "#food-icon-a-008-drink",
    "#food-icon-a-002-drink",
    "#food-icon-a-009-sweet",
    "#food-icon-a-006-drink",
    "#food-icon-a-007-strawberry",
    "#food-icon-a-004-cup",
    "#food-icon-a-022-glass",
    "#food-icon-a-015-drink",
    "#food-icon-a-013-drink",
    "#food-icon-a-025-drink",
    "#food-icon-a-017-drink",
    "#food-icon-a-014-glass",
    "#food-icon-a-019-alcohol",
    "#food-icon-a-016-moccha",
    "#food-icon-a-020-milk",
    "#food-icon-a-023-drink",
    "#food-icon-a-021-milk",
    "#food-icon-a-027-tropical",
    "#food-icon-a-029-drink",
    "#food-icon-a-010-fruit",
    "#food-icon-a-028-healthy",
    "#food-icon-a-012-drink",
    "#food-icon-a-030-drink",
    "#food-icon-a-005-softdrinkcan",
    "#food-icon-a-018-hotamericano",
    "#food-icon-a-026-drink",
    "#food-icon-a-024-drink",
    "#food-icon-a-001-sweet",
    "#food-icon-a-003-whiskey",
    "#food-icon-a-008-drink",
    "#food-icon-a-002-drink",
    "#food-icon-a-009-sweet",
    "#food-icon-a-006-drink",
    "#food-icon-a-007-strawberry",
    "#food-icon-a-004-cup",
    "#food-icon-a-022-glass",
    "#food-icon-a-015-drink",
    "#food-icon-a-013-drink",
    "#food-icon-a-025-drink",
    "#food-icon-a-017-drink",
    "#food-icon-a-014-glass",
    "#food-icon-a-019-alcohol",
    "#food-icon-a-016-moccha",
    "#food-icon-a-020-milk",
    "#food-icon-a-023-drink",
    "#food-icon-a-021-milk",
    "#food-icon-a-027-tropical",
    "#food-icon-a-029-drink",
    "#food-icon-a-010-fruit",
    "#food-icon-a-028-healthy",
    "#food-icon-a-012-drink",
    "#food-icon-a-030-drink"
  ]

export {
    iconList
}